/** @see: src/errors/app.ts */

export enum ErrorMessage {
  // FatalErrors - Fullpage
  SYSTEM_ERROR = 'SYSTEM_ERROR',
}

export enum ErrorCode {
  UNKNOWN = 'unknown-error',
  FATAL_ERROR = 'FATAL_ERROR',
  FATAL = 'fatal',
  NOT_FOUND = 'not-found',
  PERMISSION_DENIED = 'forbidden',
  IMPLEMENTATION_DEFECT = 'implementation-defect',
  INTERNAL = 'internal',
  INTERNAL_1 = 'INTERNAL',
  INVALID_TENANT_ID = 'invalid-tenant-id',
  INCOMPLETE_OPERATION = 'incomplete-operation',
  SESSION_EXPIRED = 'session-expired',
  TENANT_NOT_FOUND = 'tenant-not-found',
  INVALID_CREDENTIALS = 'invalid-credentials',
  IID_INVALID_CREDENTIALS = 'iid-invalid-credentials',
  ACCOUNT_LOCKED = 'idp-locked',
  CAMERA_IN_USE = 'camera-in-use',
  FACTORS_INSUFFICIENT = 'factors-insufficient',
  USER_NOT_FOUND = 'user-not-found',
  OFFLINE = 'offline',
  PUSH_REJECTED = 'rejected',
  LIVENESS_FAILED = 'liveness',
  FACTOR_LOCK_PERSISTENT = 'factor-locked-persistent',
  FACTOR_LOCK_TEMPORARY = 'factor-locked-temporary',
  FACTOR_CAPTURE_FAILED = 'factor-capture-failed',
  FACE_TIMEOUT = 'face-timeout',
  FACE_LOCK_PERSISTENT = 'factor-locked-persistent',
  RBA_ACCESS_DENIED = 'rba-access-denied',
}

export enum ErrorScreens {
  ACCOUNT_LOCKED = 'idp-locked',
}
